import { render, staticRenderFns } from "./CurationInfoCard.vue?vue&type=template&id=6f2e0bd3&scoped=true"
import script from "./CurationInfoCard.vue?vue&type=script&lang=js"
export * from "./CurationInfoCard.vue?vue&type=script&lang=js"
import style0 from "./CurationInfoCard.vue?vue&type=style&index=0&id=6f2e0bd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2e0bd3",
  null
  
)

export default component.exports